import type { ReactNode } from 'react';

import { IconButton } from '@zen/DesignSystem';
import type { TableColumn } from '@zen/DesignSystem/types';

import type { WorkflowRuleFieldTableItem, WorkflowRulesListItem } from '../types';
import { getRuleColumns } from './helpers';

interface ConfigurationArgs {
  onDelete: (workflowRuleId: string) => void;
  onEdit: (workflowRuleId: string) => void;
  ruleInputFields: WorkflowRuleFieldTableItem[];
  ruleOutputFields: WorkflowRuleFieldTableItem[];
}

export const getColumnsConfiguration = ({
  onDelete,
  onEdit,
  ruleInputFields,
  ruleOutputFields
}: ConfigurationArgs): TableColumn<WorkflowRulesListItem>[] => {
  const inputColumns = getRuleColumns(ruleInputFields);
  const outputColumns = getRuleColumns(ruleOutputFields);

  const actions: TableColumn<WorkflowRulesListItem> = {
    sortable: false,
    fixed: 'right',
    key: 'tableActions',
    render: (_, { id }): ReactNode => {
      return (
        <div className="flex space-x-2">
          <IconButton icon="zicon-edit" onClick={() => onEdit(id)} size="medium" title="Edit" variant="ghost" />
          <IconButton icon="zicon-trash" onClick={() => onDelete(id)} size="medium" title="Delete" variant="ghost" />
        </div>
      );
    }
  } as TableColumn<WorkflowRulesListItem>;

  return [...inputColumns, ...outputColumns, { ...actions, fixed: 'right' }];
};
